<template>
    <div class="form-group clearfix">
        <div class="col-md-6">
            <label>С</label> <span class="text-muted small">(00:00:00)</span>
            <input type="text" name="date_start" v-model="date_start" id="datetimepicker_start" class="form-control">
        </div>
        <div class="col-md-6">
            <label>По</label> <span class="text-muted small">(23:59:59)</span>
            <input type="text" name="date_finish" v-model="date_finish" id="datetimepicker_finish" class="form-control">
        </div>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                date_start: '',
                date_finish: ''
            };
        },
        mounted: function() {
            $("#datetimepicker_start").on(
                "changeDate", () => {this.date_start = document.getElementById('datetimepicker_start').value}
            );
            $("#datetimepicker_finish").on(
                "changeDate", () => {this.date_finish = document.getElementById('datetimepicker_finish').value}
            );
        },
        watch: {
            'date_start' : function(val) {
                this.$root.$emit('update:date_time_range', {'date_time_start': val, 'date_time_finish': this.date_finish});
            },
            'date_finish' : function(val) {
                this.$root.$emit('update:date_time_range', {'date_time_start': this.date_start, 'date_time_finish': val});
            }
        }
    }
</script>
